export const getRanks = () => {
  return [
    { value: 1, label: "اول" },
    { value: 2, label: "دوم" },
    { value: 3, label: "سوم" },
    { value: 4, label: "سوم مشترک" },
  ];
};

export const getStatuses = () => {
  return [
    { value: 0, label: "در انتظار بررسی" },
    { value: 1, label: "تایید" },
    { value: 2, label: "رد" },
  ];
};
